<template>
  <div class="main table-box">
    <global-tag>
      <el-form label-width="120px" :model="queryInfo">
        <div class="searchBox">
          <div class="content">
            <el-row>
              <el-col :span="5">
                <el-form-item label="加盟商名称：">
                  <el-input
                    clearable
                    v-model.trim="queryInfo.franchiseeName"
                    style="width: 100%"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="5">
                  <el-form-item label="所属机构：">
                      <el-select
                          style="width: 100%"
                          v-model="
                              queryInfo.serviceStationType
                          "
                          placeholder="请选择"
                      >
                          <el-option
                              v-for="item in typeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                          >
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col> -->
            </el-row>
          </div>
          <div class="btn">
            <el-button type="primary" @click="querySearch" class="searchBtns"
              >查询
            </el-button>
          </div>
        </div>
      </el-form>
    </global-tag>
    <div class="table_title">
      <div class="btn_group">
        <el-button
          type="success"
          class="openBtns"
          size="medium"
          @click="addServices('新增', 'add')"
          >新增
        </el-button>
        <el-button
          type="primary"
          class="downOutBtns"
          size="medium"
          @click="createExcel"
          >导出数据
        </el-button>
        <!-- <div style="display: none">
            <input @change="fileChange" id="speechUpload" type="file" />
        </div>
        <label for="speechUpload" class="labelImportBtn">
            <span>导入</span>
        </label> -->
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{
          background: '#e6e6e6',
          color: '#000',
        }"
        border
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="加盟商编号"
          align="center"
          prop="franchiseeNumber"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '加盟商编号') !=
            -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="加盟商名称"
          align="center"
          prop="franchiseeName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '加盟商名称') !=
            -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="所属机构"
          align="center"
          prop="statName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '所属机构') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构电话"
          align="center"
          prop="telphone"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构电话') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="地址"
          align="center"
          prop="address"
          v-if="this.tempTableChekbox.findIndex((item) => item == '地址') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
          v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
        >
          <template slot-scope="scope">
            <span @click="addServices('详情', scope.row)" class="operBtn"
              >查看</span
            >
            <span @click="addServices('编辑', scope.row)" class="operBtn"
              >编辑</span
            >

            <span @click="deleteItem(scope.row)" class="operBtn">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        :page-size="pageOne.pageSize"
        :current-page.sync="pageOne.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOne.total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-service>
  </div>
</template>
<script>
import addService from "./components/addService"

export default {
  name: "serviceMange",
  inject: ["reload"], //注入
  components: { addService },
  data() {
    return {
      typeOptions: [{ value: "1", label: "居家养老机构" }],
      pageOne: { total: 0, pageSize: 10, pageNo: 1 },
      tableData: [],
      queryInfo: { serviceStationType: "", franchiseeName: "" },
      serviceState: false,
      serviceInfo: {},

      tempTableChekbox: [
        "序号",
        "加盟商编号",
        "加盟商名称",
        "所属机构",
        "机构电话",
        "地址",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "加盟商编号",
        "加盟商名称",
        "所属机构",
        "机构电话",
        "地址",
        "操作",
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        franchiseeName: this.queryInfo.franchiseeName,
        serviceStationType: this.queryInfo.serviceStationType,
      }
      this.$http
        .request({
          url: "/ypt/admin/franchisee/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            // if (res.content.list.length > 0) {
            //     res.content.list.forEach((item) => {
            //         item.hasChagned =
            //             Number(item.counts) - Number(item.stock)
            //     })
            // }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id,
      }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/franchisee/info/deleteById",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              // this.tableData = [];
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    // 取消新增、编辑、查看
    cancleService(state) {
      this.serviceState = false

      if (state == true) {
        this.getList()
      }
    },

    // 新增\编辑\查看
    addServices(title, row) {
      this.serviceState = true

      this.serviceInfo = {}
      this.serviceInfo = {
        title: title,
        id: title == "新增" ? "" : row.id,
        state: true,
      }
    },

    // 页面刷新
    reset() {
      this.reload()
    },
    // 搜索
    querySearch() {
      this.getList()
    },
    //导出excel
    async createExcel() {
      const res = await this.request2({
        url: "/ypt/admin/franchisee/info/downloadExcel",
        method: "POST",
        data: {},
        responseType: "blob",
      })
      const blob = new Blob([res], { type: "application/vnd.ms-excel" })
      const fileName = "加盟商管理.xls"
      const linkNode = document.createElement("a")

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    // 导入
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = "1"
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      console.log(formData)
      formData.append("file", file)
      let result = await this.$http.post(
        "/ypt/admin/franchisee/info/excel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code == 200) {
        this.$message.success(result.message)
        this.getList()
      } else {
        this.$message.warning(result.message)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .table_title {
  margin-top: 15px !important;
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.labelImportBtn {
  background: orange;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 10px;
  font-size: 12px;
  padding: 4px 24px;
  color: #fff;
  line-height: 28px;
  display: inline-block;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
